
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/beaches-surfing",
      function () {
        return require("private-next-pages/beaches-surfing.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/beaches-surfing"])
      });
    }
  